// libs
import styled from 'styled-components'
// components
import { Paper as PaperOrigin, Typography } from 'components/UI'
// icons
import EditIconOrigin from '@mui/icons-material/EditRounded'
// themes
import { colors } from 'themes'

export const Paper = styled(PaperOrigin)`
    && {
        width: 100%;
        padding: 20px;
    }
`

export const Content = styled.div`
    white-space: pre-wrap;
    color: ${colors.gray300};
    margin-top: 10px;
`

export const EditIcon = styled(EditIconOrigin)`
    cursor: pointer;
`

export const Title = styled(Typography)`
    && {
        font-size: 18px;
        font-weight: bold;
    }
`
